import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as Auth from "../../../Login/Auth"
import * as apiCompany from "../../../../api/apiCompany"
import { ItemRoleName, ItemRoleListSelect, ItemRoleIsSupervisor, ItemRoleIsDisable } from '../../item/RoleItems';
import { RoleContent } from './RoleContent';
import { SubmitButton, CancelButton } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';


export function AdminRoleEdit ({role, cancel}) {
  const[mRole, setRole] = useState({})
  const[roleName, setRoleName] = useState(role.roleName)
  const[isSupervisor, setIsSupervisor] = useState(role.isSupervisor)
  const[managerRoleId, setManagerRoleId] = useState(role.managerRoleId)
  const [isDisable, setisDisable] = useState(role.isDisable)

  var title = '角色 - 編輯'
  var title_tools = ''
  var content = <RoleContent departmentId={mRole.departmentId} role={mRole} sn={setRoleName} ss={setIsSupervisor} sm={setManagerRoleId} sd={setisDisable} />
  var footer =
    <div class="row">
      <div class="col-sm-3 col-sm-offset-9">
        <SubmitButton action={toEdit} isRight={true} />
        <CancelButton action={cancel} isRight={true} />
      </div>
    </div>


  useEffect(()=>{
    if(mRole !== role){
      setRole(role)
      setRoleName(role.roleName)
      setIsSupervisor(role.isSupervisor)
      setManagerRoleId(role.managerRoleId)
      setisDisable(role.isDisable)
    }
  })

  function toEdit(){
    if(roleName !== ""){
      var token = Auth.getToken();
      apiCompany.roleEdit({
        roleId: role.roleId, roleName, 
        departmentId: role.departmentId, isSupervisor, managerRoleId, isDisable, 
        success: (obj)=>{
          Swal.fire({
            type: 'success',
            title: '提醒',
            text: '修改成功',
          }).then(function() {
            cancel(false)
            //window.history.replace("/ManagerList");
          })
        },
        failure: ()=>{
          
        }
      })
    }else{
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '公司名稱 不得為空',
      })
    }
  }

    return (    
      <ContentBox title={title} title_tools={title_tools} content={content} footer={footer}  hasDrawer={true} />
    )
}